<template>
    <div class="flex flex-col items-center justify-center mt-8 mx-6 px-12 pt-12 pb-8 bg-white">
        <img :src="notfoundIcon" alt="Not Found">
        <div class="space-y-4 py-8">
            <h1 class="text-2xl font-bold text-center">ページが見つかりませんでした</h1>
            <p class="text-sm">お探しのページは移動もしくは削除された可能性があります。</p>
        </div>
        <a href="/article-management" class="btn-secondary">記事管理ページへ</a>
    </div>
</template>

<script>
import { useRouter } from 'vue-router';
import notfoundIcon from '@/assets/404.svg';

export default {
    setup() {
        const router = useRouter();

        function goBack() {
            router.push({ name: 'Dashboard' });
        }

        return {
            notfoundIcon,
            goBack
        };
    }
}
</script>

<style scoped>
/* ここに追加のスタイリングを記述できます */
</style>
